import React from "react";
import TheNav from "../Components/navbar";
import EditorProfile from "../Components/editorProfileScreen";
import SEO from "../Components/SEO";

const editorPortfolio = () => {
  return (
    <>
      <SEO
        title="Editor Portfolio Workspace | Kre8"
        description="Private Kre8 editor portfolio workspace."
        canonicalPath="/editorPortfolio"
        noindex
      />
      <TheNav />
      <EditorProfile />
    </>
  );
};

export default editorPortfolio;
